import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// DELETE /api/settings/notifications/rules/:id
//
// System rules raise 403 system_rule_protected via the DB trigger; the SPA
// shows a tailored message in that case.
export function useDeleteNotificationRule() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, string>({
    mutationFn: (ruleId) =>
      apiFetch<{ ok: true }>(`/settings/notifications/rules/${ruleId}`, {
        method: "DELETE",
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.settings.notificationRules() });
      queryClient.invalidateQueries({
        queryKey: queryKeys.settings.notificationInsights(),
      });
    },
    onError: (err) => {
      if (err.code === "system_rule_protected") {
        toast.error("System rules can be toggled but not deleted.");
        return;
      }
      toast.error(err.message ?? "Failed to delete notification rule");
    },
  });
}
